import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { SpinerService } from '../services/spinner/spinner-service';
import { ToastService } from '../services/toast/toast.service';

export function errorInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  const toast = inject(ToastService);
  const spinner = inject(SpinerService);

  return next(req).pipe(
    catchError((response: HttpErrorResponse) => {
      const { status, error } = response;

      // 401 (handled by auth interceptor / redirect), 404 (often page-level),
      // and ALREADY_PROCESSED 409s (feature shows its own banner) are
      // suppressed at the toast layer.
      if ([401, 404].includes(status) || error?.error_code === 'ALREADY_PROCESSED') {
        spinner.hideIfActive();
        return throwError(() => error);
      }

      const errorMessage =
        (Array.isArray(error?.errors) && error.errors[0]) ||
        // Some endpoints nest the user-facing error under `data.errors` while
        // the top-level `errors` is empty (e.g. the DCC regrade / ControlHub
        // envelope) — prefer that over the verbose `messages` log lines below.
        (Array.isArray(error?.data?.errors) && error.data.errors[0]) ||
        (typeof error?.message === 'string' && error.message) ||
        (typeof error?.error === 'string' && error.error) ||
        (typeof error === 'string' && error) ||
        (Array.isArray(error?.messages) && error.messages[error.messages.length - 1]) ||
        response.message ||
        'An unexpected error occurred. Please try again.';
      toast.error(errorMessage);
      spinner.hideIfActive();
      return throwError(() => error);
    }),
  );
}
